import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Tabs } from "@helloaudio/ui";
import { PuffLoader } from "react-spinners";
import Appearance from "./Tab/Appearance";
import ShareEpisode from "./Tab/ShareEpisode";
import AIContent from "./Tab/AIContent";

function Loading() {
  return (
    <div className="loading-container">
      <h3 style={{ textAlign: "center" }}>
        <PuffLoader color="#32325d" size={150} aria-label="Loading Spinner" data-testid="loader" />
        Loading
      </h3>
    </div>
  );
}

function EditEpisode({
  existingFeedEpisodeId,
  feedEpisode,
  feedId,
  getEmbedCode,
  getEmbedCodeSlim,
  getEpisodeShareCode,
  handleSubmit,
  setFieldValue,
  values,
}) {
  const formValue = useSelector((state) => state.basic);
  const {
    loading: { "save-feed-episode": saveFeedEpisodeLoading },
    localUser: { ai_content_enabled: aiContentEnabled },
  } = formValue;
  return (
    <React.Fragment>
      <Tabs
        className="tw-h-full tw-flex tw-flex-col"
        tabs={[{ label: "Appearance" }, { label: "Share Episode" }, { label: "AI Content" }]}
        tabsClassName="tw--mx-[15px] tw-font-Montserrat"
      >
        {(index) => (
          <Suspense fallback={<Loading />}>
            {index === 0 && (
              <Appearance
                setFieldValue={setFieldValue}
                values={values}
                feedEpisode={feedEpisode}
                handleSubmit={handleSubmit}
                loading={saveFeedEpisodeLoading}
              />
            )}
            {index === 1 && (
              <ShareEpisode
                feedId={feedId}
                feedEpisode={feedEpisode}
                existingFeedEpisodeId={existingFeedEpisodeId}
                getEmbedCode={getEmbedCode}
                getEmbedCodeSlim={getEmbedCodeSlim}
                getEpisodeShareCode={getEpisodeShareCode}
              />
            )}
            {index === 2 && (
              <AIContent
                aiContentEnabled={aiContentEnabled}
                feedEpisode={feedEpisode}
                feedEpisodeId={existingFeedEpisodeId}
              />
            )}
          </Suspense>
        )}
      </Tabs>
    </React.Fragment>
  );
}

EditEpisode.propTypes = {
  existingFeedEpisodeId: PropTypes.string,
  feedEpisode: PropTypes.object,
  feedId: PropTypes.string,
  getEmbedCode: PropTypes.func,
  getEmbedCodeSlim: PropTypes.func,
  getEpisodeShareCode: PropTypes.func,
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
};

export default EditEpisode;
